class groups {
  constructor(groupId, name) {
    this.groupId = groupId;
    this.name = name;
  }
  static fromJson({ GrupoId, Nombre }) {
    return new groups(GrupoId, Nombre);
  }
}
export default groups;
